import React from 'react';
import { css } from '@emotion/react';
import { colors, fontStyles, spacing } from '../../styles';
import { getNotificationDescription } from '../../utils/notificationHelpers';
import ToggleSwitch from '../ToggleSwitch';
import { NotificationPreference } from '../../hooks/useNotificationPreferences';

interface NotificationListItemProps {
  preference: NotificationPreference;
  onToggle: (id: string) => void;
}

const NotificationListItem: React.FC<NotificationListItemProps> = ({ preference, onToggle }) => {
  const isSmartSummary = preference.id === 'smart_notifications';

  return (
    <div
      css={css`
        padding: ${spacing.deci};
        background-color: var(--card-background);
        border-radius: 8px;
        border-left: 4px solid ${preference.enabled ? colors.petrolBlue : 'transparent'};
        transition: all 0.3s ease;

        &:hover {
          transform: translateX(2px);
        }
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <div
          css={css`
            flex: 1;
            margin-right: ${spacing.deci};
            position: relative;
          `}
        >
          <p
            css={css`
              ${fontStyles.cat};
              color: var(--text-color);
              margin: 0 0 ${spacing.micro} 0;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: ${spacing.milli};
            `}
          >
            {preference.description}
            {isSmartSummary && (
              <span
                css={css`
                  background: ${colors.petrolBlue};
                  color: ${colors.sugar};
                  padding: 2px ${spacing.milli};
                  border-radius: 4px;
                  ${fontStyles.flea}
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                `}
              >
                Pro
              </span>
            )}
          </p>
          <p
            css={css`
              ${fontStyles.thinFlea};
              margin: 0;
              color: var(--secondary-text);
              opacity: 0.8;
              html[data-theme='dark'] & {
                color: ${colors.sugar};
                opacity: 0.7;
              }
            `}
          >
            {getNotificationDescription(preference.id)}
          </p>
        </div>
        <ToggleSwitch checked={preference.enabled} onChange={() => onToggle(preference.id)} />
      </div>
    </div>
  );
};

export default NotificationListItem;
